<template>
  <span
    class="absolute right-0 top-px z-[3] inline-flex h-[27px] items-center whitespace-nowrap rounded-[0_12px_0_10px] bg-red-500 px-2.5 pb-px text-[12px] font-medium leading-[15px] text-white"
  >
    <svg
      aria-hidden="true"
      viewBox="0 0 20 15"
      class="pointer-events-none absolute -top-px right-full -mr-px block h-[15px] w-5"
    >
      <g transform="rotate(180 10 7.5)">
        <path
          d="M 0 0 L 0 15 L 20 15 L 20 14 L 11 14 A 10 10 0 0 1 1 4 L 1 0 Z"
          fill="#dc3c3f"
        />
      </g>
    </svg>
    <span><slot /></span>
    <svg
      aria-hidden="true"
      viewBox="0 0 20 15"
      class="pointer-events-none absolute right-0 top-full -mt-px block h-[15px] w-5"
    >
      <g transform="rotate(180 10 7.5)">
        <path
          d="M 0 0 L 0 15 L 20 15 L 20 14 L 11 14 A 10 10 0 0 1 1 4 L 1 0 Z"
          fill="#dc3c3f"
        />
      </g>
    </svg>
  </span>
</template>

<script setup lang="ts"></script>
